import { SiteLoader } from '@common/components';
import { ReactNode, FC, useEffect, useState } from 'react';
import { FreePlanRoutes, PrivateRoutes } from 'src/router';
import { useAppDispatch, useAppSelector } from 'src/store';
import { paymentInfoAction } from 'src/store/payment';

interface Props {
  children: ReactNode;
}

const PaymentProvider = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { tenantId } = useAppSelector((state) => state.user.data);
  const {  data } = useAppSelector((state) => state.payment);
  const [ isLoading , setIsLoading ] = useState(true)
  useEffect(() => {    
    if (tenantId) {
      dispatch(paymentInfoAction({
        submitCallback : (data:any) => {
          setIsLoading(false);
        }
      }))
    }
  }, [tenantId]);
  
  if ( isLoading  ) {
    return <SiteLoader />;
  }

  if ( !isLoading && ['free', 'free plan'].includes(data?.paymentPlan)  ) {
    return <FreePlanRoutes/>
  }
return  <PrivateRoutes />
};

export default PaymentProvider;
